export type GailUniversityVideoProvider = "tella" | "you_tube" | "loom" | "vimeo";

export type GailUniversityProductTag = "gail_gpt" | "gail_agent";

export type GailUniversityLocalizedText = Record<string, string>;

export type GailUniversityVideo = {
  id: string;
  name: GailUniversityLocalizedText;
  description?: GailUniversityLocalizedText | null;
  videoUrl: string;
  embedUrl: string;
  provider: GailUniversityVideoProvider;
  groupKey?: string | null;
  groupName?: GailUniversityLocalizedText | null;
  groupOrder: number;
  productTags: GailUniversityProductTag[];
  sortOrder: number;
  isPublished: boolean;
  createdAt: string;
  updatedAt: string;
};

export type GailUniversityVideoGroup = {
  key: string;
  name: string;
  order: number;
  videos: GailUniversityVideo[];
};

export const GAIL_UNIVERSITY_PRODUCT_TAGS: readonly GailUniversityProductTag[] = [
  "gail_gpt",
  "gail_agent",
];

export const GAIL_UNIVERSITY_PRODUCT_TAG_LABELS: Record<GailUniversityProductTag, string> = {
  gail_gpt: "GailGPT",
  gail_agent: "GailAgent",
};

export const GAIL_UNIVERSITY_PROVIDER_LABELS: Record<GailUniversityVideoProvider, string> = {
  tella: "Tella",
  you_tube: "YouTube",
  loom: "Loom",
  vimeo: "Vimeo",
};
